import { HttpClient } from '@angular/common/http';
import BigNumber from 'bignumber.js';
import { tap } from 'rxjs/operators';
import { Base } from '../base';

export class Rounds extends Base {
  constructor(protected httpClient: HttpClient, private parent: string) {
    super(httpClient, `${parent}/rounds`);
  }

  getCurrent() {
    return this.api.get('current').pipe(
      tap((json) => this.processRecord(json.round))
    )
  }

  private processRecord(record: any) {
    record.subscriptionShares = new BigNumber(record.subscriptionShares).fromDecimal();
    record.subscriptionFunds = new BigNumber(record.subscriptionFunds).fromDecimal();
    record.redemptionShares = new BigNumber(record.redemptionShares).fromDecimal();
    record.redemptionFunds = new BigNumber(record.redemptionFunds).fromDecimal();
  }
}
